import { render, staticRenderFns } from "./OrderOtherPricePopup.vue?vue&type=template&id=272b869c&scoped=true"
import script from "./OrderOtherPricePopup.vue?vue&type=script&lang=js"
export * from "./OrderOtherPricePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272b869c",
  null
  
)

export default component.exports